const langAuthOktaFactorQuestion = {
	question_option_label_disliked_food: {
		tag: 'auth.okta_factor_question.question_option_label_disliked_food',
		fr: "Quel est l'aliment que vous aimiez le moins quand vous étiez enfant ?",
		en: 'What is the food you least liked as a child?',
	},

	question_option_label_name_of_first_plush_toy: {
		tag: 'auth.okta_factor_question.question_option_label_name_of_first_plush_toy',
		fr: 'Quel est le nom de votre premier animal en peluche ?',
		en: 'What is the name of your first stuffed animal?',
	},
	question_option_label_first_award: {
		tag: 'auth.okta_factor_question.question_option_label_first_award',
		fr: 'Pour quelle raison avez-vous obtenu votre première médaille ou récompense ?',
		en: 'What did you earn your first medal or award for?',
	},
	question_option_label_favorite_toy: {
		tag: 'auth.okta_factor_question.question_option_label_favorite_toy',
		fr: "Quel est le jouet ou l'animal en peluche que vous aimiez le plus quand vous étiez enfant ?",
		en: 'What is the toy/stuffed animal you liked the most as a kid?',
	},
	question_option_label_first_computer_game: {
		tag: 'auth.okta_factor_question.question_option_label_first_computer_game',
		fr: 'Quel est le premier jeu vidéo auquel vous avez joué ?',
		en: 'What was the first computer game you played?',
	},
	question_option_label_favorite_movie_quote: {
		tag: 'auth.okta_factor_question.question_option_label_favorite_movie_quote',
		fr: 'Quelle est votre citation de film préférée ?',
		en: 'What is your favorite movie quote?',
	},
	question_option_label_first_sports_team_mascot: {
		tag: 'auth.okta_factor_question.question_option_label_first_sports_team_mascot',
		fr: 'Quelle était la mascotte de la première équipe sportive dans laquelle vous avez joué ?',
		en: 'What was the mascot of the first sports team you played on?',
	},
	question_option_label_first_music_purchase: {
		tag: 'auth.okta_factor_question.question_option_label_first_music_purchase',
		fr: 'Quel album de musique ou quelle chanson avez-vous acheté pour la première fois ?',
		en: 'What music album or song did you first purchase?',
	},
	question_option_label_favorite_art_piece: {
		tag: 'auth.okta_factor_question.question_option_label_favorite_art_piece',
		fr: "Quelle est votre œuvre d'art préférée ?",
		en: 'What is your favorite piece of art?',
	},
	question_option_label_grandmother_favorite_desert: {
		tag: 'auth.okta_factor_question.question_option_label_grandmother_favorite_desert',
		fr: 'Quel était le dessert préféré de votre grand-mère ?',
		en: "What was your grandmother's favorite dessert?",
	},
	question_option_label_first_thing_cooked: {
		tag: 'auth.okta_factor_question.question_option_label_first_thing_cooked',
		fr: 'Quelle est la première chose que vous avez appris à cuisiner ?',
		en: 'What was the first thing you learned to cook?',
	},
	question_option_label_childhood_dream_job: {
		tag: 'auth.okta_factor_question.question_option_label_childhood_dream_job',
		fr: 'Quel était le métier de vos rêves quand vous étiez enfant ?',
		en: 'What was your dream job as a child?',
	},
	question_option_label_place_where_significant_other_was_met: {
		tag: 'auth.okta_factor_question.question_option_label_place_where_significant_other_was_met',
		fr: 'Où avez-vous rencontré votre époux/épouse/conjoint(e) ?',
		en: 'Where did you meet your spouse/significant other?',
	},
	question_option_label_favorite_vacation_location: {
		tag: 'auth.okta_factor_question.question_option_label_favorite_vacation_location',
		fr: 'Où êtes-vous allé pour vos vacances préférées ?',
		en: 'Where did you go for your favorite vacation?',
	},
	question_option_label_new_years_two_thousand: {
		tag: 'auth.okta_factor_question.question_option_label_new_years_two_thousand',
		fr: 'Où étiez-vous le soir du Nouvel An 2000 ?',
		en: "Where were you on New Year's Eve in the year 2000?",
	},
	question_option_label_favorite_speaker_actor: {
		tag: 'auth.okta_factor_question.question_option_label_favorite_speaker_actor',
		fr: 'Quel est votre orateur/conférencier préféré ?',
		en: 'Who is your favorite speaker/orator?',
	},
	question_option_label_favorite_sports_player: {
		tag: 'auth.okta_factor_question.question_option_label_favorite_sports_player',
		fr: 'Quel est votre joueur de sport préféré ?',
		en: 'Who is your favorite sports player?',
	},
	question_option_label_favorite_book_movie_character: {
		tag: 'auth.okta_factor_question.question_option_label_favorite_book_movie_character',
		fr: 'Quel est votre personnage de livre ou de film préféré ?',
		en: 'Who is your favorite book/movie character?',
	},
	field_label_question_key: {
		tag: 'auth.okta_factor_question.field_label_question_key',
		fr: 'Sélectionnez une question',
		en: 'Select a question',
	},
	field_label_answer: {
		tag: 'auth.okta_factor_question.field_label_answer',
		fr: 'Réponse à la question secrète',
		en: 'Your answer',
	},
	btn_save: {
		tag: 'auth.okta_factor_question.btn_save',
		fr: 'Enregistrer',
		en: 'Save',
	},
	error_question_key_required: {
		tag: 'auth.okta_factor_question.error_question_key_required',
		fr: 'Veuillez sélectionner une question',
		en: 'Please, select a question',
	},
	error_answer_required: {
		tag: 'auth.okta_factor_question.error_answer_required',
		fr: 'Veuillez saisir une réponse',
		en: 'Type an answer',
	},
	error_answer_too_short: {
		tag: 'auth.okta_factor_question.error_answer_too_short',
		fr: 'La réponse est trop courte',
		en: 'The answer is too short',
	},
	error_api: {
		tag: 'auth.okta_factor_question.error_api',
		fr: "Impossible d'enregistrer votre réponse",
		en: 'Unable to save your answer',
	},
};

export default langAuthOktaFactorQuestion;
